import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LeaPDPersonSearchResultDto, LeaSiteCodeDto } from '../../services/api.service';
import { BulkEinFormatterModalComponent } from './bulk-ein-formatter-modal/bulk-ein-formatter-modal.component';

export interface PersonSearchParams {
  firstName: string;
  lastName: string;
  ein: string;
  leaSiteCodeId: number | null;
}

@Component({
  selector: 'cert-pd-advanced-person-search',
  standalone: false,
  templateUrl: './pd-advanced-person-search.component.html',
})
export class PDAdvancedPersonSearchComponent {
  constructor(private readonly modalService: NgbModal) {}
  @Input() results: LeaPDPersonSearchResultDto[] = [];
  @Input() selectedPersonIds: number[] = [];
  @Input() unmatchedEins: string[] = [];
  @Input() searching = false;
  @Input() searchPerformed = false;
  @Input() leaSiteCodes: LeaSiteCodeDto[] = [];

  @Output() search = new EventEmitter<PersonSearchParams>();
  @Output() bulkSearch = new EventEmitter<string[]>();
  @Output() addAll = new EventEmitter<void>();
  @Output() relaySelect = new EventEmitter<LeaPDPersonSearchResultDto>();
  @Output() relayDeselect = new EventEmitter<LeaPDPersonSearchResultDto>();

  firstName = '';
  lastName = '';
  ein = '';
  bulkEinInput = '';
  leaSiteCodeId = null;

  onSearch() {
    if (!this.firstName && !this.lastName && !this.ein && !this.leaSiteCodeId) return;
    this.searching = true;
    this.searchPerformed = true;
    this.search.emit({
      firstName: this.firstName,
      lastName: this.lastName,
      ein: this.ein,
      leaSiteCodeId: this.leaSiteCodeId,
    });
  }

  onClear() {
    this.firstName = '';
    this.lastName = '';
    this.ein = '';
    this.leaSiteCodeId = null;
    this.searchPerformed = false;
    this.searching = false;
    this.search.emit({ firstName: '', lastName: '', ein: '', leaSiteCodeId: 0 });
  }

  onBulkClear() {
    this.bulkEinInput = '';
    this.unmatchedEins = [];
    this.searchPerformed = false;
    this.searching = false;
    this.search.emit({ firstName: '', lastName: '', ein: '', leaSiteCodeId: 0 });
  }

  onBulkSearch() {
    const eins = this.parseBulkEins();
    if (eins.length > 0) {
      this.searching = true;
      this.searchPerformed = true;
      this.bulkSearch.emit(eins);
    }
  }

  onAddAll() {
    this.addAll.emit();
  }

  isSelected(personId: number): boolean {
    return this.selectedPersonIds.includes(personId);
  }

  relaySelectEvent(person: LeaPDPersonSearchResultDto) {
    this.relaySelect.emit(person);
  }

  relayDeselectEvent(person: LeaPDPersonSearchResultDto) {
    this.relayDeselect.emit(person);
  }

  openBulkFormatterModal() {
    this.modalService.open(BulkEinFormatterModalComponent, {
      backdrop: 'static',
      size: 'lg',
      centered: true,
    });
  }

  private parseBulkEins(): string[] {
    return this.bulkEinInput
      .split(',')
      .map((s) => s.trim().toUpperCase())
      .filter((s) => s.length > 0);
  }
}
